module.exports = __webpack_public_path__ + "img/triathlon.51afdd4a.webp";